import { t } from 'i18next';
import { SetStateAction } from 'react';
import { Visibility } from '../../../../enum/Visibility';
import GeoSummaryRowOptions from './GeoSummaryRowOptions';
import sum from '../../../../assets/img/svg/buttons/sum.svg';
import { useGeoSummaryDropdown } from '../../../../hook/useGeoSummaryDropdown';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { persistColumnConfig } from '../../../../util/persist-column-config';
import { useAllFilters } from '../../../../hook/useAllFilters';

interface GeoSummaryDropdownProps {
  showDropdown: boolean;
  setShowDropdown: React.Dispatch<SetStateAction<boolean>>;
}

const GeoSummaryDropdown: React.FC<GeoSummaryDropdownProps> = ({ showDropdown, setShowDropdown }) => {
  const { columns, checkedColumns, handleToggleColumn, handlePinToggle } = useGeoSummaryDropdown();
  const { handleApplyAllFilters } = useAllFilters();

  const dispatch = useAppDispatch();

  return (
    <div className={`geo_summary_dropdown ${showDropdown ? Visibility.VISIBLE : Visibility.HIDDEN}`}>
      <div className="geo_summary_header">
        <span className="title">{t('statisticPage.header.geoSummary.title')}</span>
      </div>

      <div className="options_container">
        {columns?.map((col, i) => {
          const isChecked = checkedColumns.includes(col.name);
          const isLastChecked = isChecked && checkedColumns.length === 1;

          return (
            <GeoSummaryRowOptions
              key={col.name}
              index={i}
              column={col}
              isSelected={isChecked}
              onSelect={() => handleToggleColumn(col.name)}
              onPinToggle={() => {
                handlePinToggle(col.name);
                persistColumnConfig(dispatch);
              }}
              disabled={isLastChecked}
            />
          );
        })}

        <hr />
        <button
          className="sum"
          disabled={checkedColumns.length === 0}
          onClick={() => {
            handleApplyAllFilters();
            setShowDropdown(false);
          }}
        >
          <img src={sum} alt="SumBy" />
          {t('statisticPage.header.geoSummary.sumBy')}
        </button>
      </div>
    </div>
  );
};

export default GeoSummaryDropdown;
